export const informationLink = "https://www.smartiscity.gr/dimos-volvi/";
export const informationLinkEN =
  "https://www.smartiscity.gr/dimos-volvi/";

export const diavLink = "https://skoufas.diavouleuseis.gr";

export const applicantsCitizen = [
  {
    name: "Σύνδεση",
    url: "https://platform.cityzenapp.gr/cityzen/dimosskoufa/login",
  },
  {
    name: "Εγγραφή",
    url: "https://platform.cityzenapp.gr/cityzen/dimosskoufa/register",
  },
  {
    name: "Πληροφορίες",
    url: "https://platform.cityzenapp.gr/cityzen/dimosskoufa/",
  },
];

export const androidAppLink =
  "https://play.google.com/store/apps/details?id=gr.dotsoft.cityzenapp.alexandria";
export const iosAppLink =
  "https://apps.apple.com/gr/app/%CE%B4%CE%B7%CE%BC%CF%8C%CF%84%CE%B7%CF%82-%CE%B1%CE%BB%CE%B5%CE%BE%CE%AC%CE%BD%CE%B4%CF%81%CE%B5%CE%B9%CE%B1%CF%82/id1667646995";

export const welcomeMessageContent = [
  "Σας καλωσορίζουμε στην Πλατφόρμα Εξυπνης Πόλης του Δήμου Ζακύνθου.",
  "Ενημερωθείτε για τις συνθήκες που επικρατούν στην πόλη μας.",
];

export const baseUrl = "https://zakynthos.smartiscity.gr";

export const allTypesUrl = baseUrl + "/api/api.php?func=sensortypes";
export const allSensorsUrl = baseUrl + "/api/api.php?func=allsensors";


export const UvUrl = baseUrl + "/api/api.php?func=indexes";
export const enviURL = baseUrl + '/api/api.php?func=envi';
export const meshURL = baseUrl + "/api/api.php?func=mesh";
// export const meteoURL = kalamariaBaseUrl + "/api/api.php?func=meteo";
export const meteoURL = baseUrl + "/api/api.php?func=meteo";
export const poiURL = baseUrl + "/api/api.php?func=pois";
export const fleetoUrl = baseUrl + "/api/api.php?func=fleeto";
// export const binsUrl = kalamariaBaseUrl + "/api/api.php?func=bins";
export const binsUrl = baseUrl + "/api/api.php?func=bins";
export const hydroUrl = baseUrl + "/api/api.php?func=hydro";
// export const weatherUrl = kalamariaBaseUrl + "/api/api.php?func=forecast";
export const weatherUrl = baseUrl + "/api/api.php?func=forecast";
export const wifiUrl = baseUrl + "/api/api.php?func=hotspot";
export const parkingUrl = baseUrl + "/api/api.php?func=parkingAll";
// export const allBinsCharts = kalamariaBaseUrl + "/api/api.php?func=allbinstats";
export const allBinsCharts = baseUrl + "/api/api.php?func=allbinstats";
// export const specificBinChart = kalamariaBaseUrl + "/api/api.php?func=binstats";
export const specificBinChart = baseUrl + "/api/api.php?func=binstats";

export const chartsUrls = baseUrl + "/api/api.php?func=stats";

export const gallerySmall = baseUrl + "/gallery/vars/Small/";
export const galleryBig = baseUrl + "/gallery/vars/Big/";

// export const cityCenter = {
//   lat: 40.5479746,
//   lng: 23.0202183,
// };
// export const cityCenter = {
//   lat: 40.5468512,
//   lng: 23.0173248,
// };
export const cityCenter = {
  lat: 37.789007,
  lng: 20.894829,
};

//37.789007, 

// settings
export const showEnvironmentAddress = true;
